// temporary component - to delete when changing cryo RA inhouse_grade into technical_evaluation
<template>
  <base-submit-info-modal ref="rapidAccessTechnicalEvaluationModal"
                          :confirm-function="saveEvaluation"
                          confirm-button-title="Save evaluation"
                          modal-title="Rapid access technical evaluation">
    <template>
      <cryoem-rapid-access-technical-evaluation-form v-model="evaluation"
                                                     :is-editable="isEvaluationEditable"
                                                     :shifts-options="shiftsOptions"/>
    </template>
    <template>
      <p class="p-form-label-with-margin-bold">Safety Manager comments</p>
      <b-form-textarea id="safety_comments"
                       v-model="proposal.experiment_color.safety_evaluation.comments_review"
                       disabled
                       rows="3"/>
      <p class="p-form-label-with-margin-bold">Radiation Manager comments</p>
      <b-form-textarea id="radiation_comments"
                       v-model="proposal.experiment_color.radiation_evaluation.comments_review"
                       class="mb-3"
                       disabled
                       rows="3"/>
    </template>
  </base-submit-info-modal>
</template>

<script>
  import BaseSubmitInfoModal from '@/components/base-components/base-modals/BaseSubmitInfoModal';
  import CryoemRapidAccessTechnicalEvaluationForm
    from '@/components/evaluation/rapid-access/technical/CryoemRapidAccessTechnicalEvaluationForm';
  import { infrastructureMixin } from '@/mixins/infrastructure';
  import { setExperimentColorAndCommentsInProposal }
    from '@/helpers/evaluation/rapid-access/rapidAccessTechnicalEvaluation';

  export default {
    name: 'CryoemRapidAccessTechnicalEvaluationModal',
    components: {
      BaseSubmitInfoModal,
      CryoemRapidAccessTechnicalEvaluationForm,
    },
    mixins: [infrastructureMixin],
    props: {
      isEvaluationEditable: {
        type: Boolean,
        required: true,
      },
      shiftsOptions: {
        type: Array,
        default: () => [],
      },
      proposalToEdit: {
        type: Object,
        required: true,
      },
    },
    data() {
      return { evaluation: {} };
    },
    computed: {
      proposal() {
        return setExperimentColorAndCommentsInProposal(this.proposalToEdit);
      },
    },
    watch: {
      proposal(newValue) {
        this.evaluation = newValue?.inhouse_grade || {};
      },
    },
    methods: {
      hide() {
        this.$refs.rapidAccessTechnicalEvaluationModal.hide();
      },
      isEvaluationSubmittable() {
        return !!this.evaluation
          && (this.evaluation.acceptance_mark !== 'rejected' || !!this.evaluation.comment);
      },
      async saveEvaluation() {
        if (this.isEvaluationEditable) {
          this.$emit('save-evaluation', this.evaluation);
          if (!this.isEvaluationSubmittable()) {
            this.$notify({
              type: 'warn',
              title: 'For \'rejected\' evaluation comment is obligatory',
            });
          }
          this.hide();
        } else {
          this.$notify({ type: 'error', title: 'Evaluation is not editable' });
        }
      },
      show() {
        this.$refs.rapidAccessTechnicalEvaluationModal.show();
      },
    },
  };
</script>
